import { render, staticRenderFns } from "./ReplyComment.vue?vue&type=template&id=9fb8f35c&scoped=true&"
import script from "./ReplyComment.vue?vue&type=script&lang=js&"
export * from "./ReplyComment.vue?vue&type=script&lang=js&"
import style0 from "./ReplyComment.vue?vue&type=style&index=0&id=9fb8f35c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb8f35c",
  null
  
)

export default component.exports